module.exports = __webpack_public_path__ + "img/seating-ushaped.30019778.svg";